module.exports = __webpack_public_path__ + "static/img/pMRI7.913b9976.png";